module.exports = __webpack_public_path__ + "static/img/5742_phase_function_Paper_Points.a2f299a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5742_phase_function_Paper_Points.png
// module id = n1bC
// module chunks = 0